import styled, { createGlobalStyle } from 'styled-components'

export const breakpoints = {
  min: {
    tablet: '576',
    laptop: '768',
    desktop: '992',
    desktopLg: '1200',
  },
  max: {
    mobile: '575',
    laptop: '767',
    desktop: '991',
    desktopLg: '1199',
  },
}

export const globalVariables = {
  colors: {
    black: '#1d242a',
    white: '#fff',
  },
  spacing: {
    section: '1em',
  },
  padding: {
    button: '.75em .425em;',
    input: '.75em .425em;',
    select: '.5em 1em;',
  },
}

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
  }
  
  body {
    padding: 0;
    margin: 0;
  }

  :root {
    font-size: 14px;
  }

  h1 {
    font-size: 1.25rem;
    font-weight: 500;
  }

  h2 {
    font-size: 1rem;
  }

  p, span {
    font-size: 1rem;
    font-weight: 300;
  }

  button, input, select {
    font-size: 1rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`

// BOOTSTRAP SCREEN SIZES
const [small, medium, large, xLarge] = [
  '(min-width: 576px)',
  '(min-width: 768px)',
  '(min-width: 992px)',
  '(min-width: 1200px)',
]

export const Container = styled.div`
  padding-left: 15px;
  padding-right: 15px;

  @media (min-width: ${breakpoints.min.tablet}px) {
    padding-left: 25px;
    padding-right: 25px;  
  }

  @media (min-width: ${breakpoints.min.laptop}px) {
    padding-left: 40px;
    padding-right: 40px;  
  }

  margin: 0 auto;
  max-width: 1340px;
  position: ${props => (props.floating ? 'absolute' : 'relative')};
  color: ${props => (props.floating ? 'white' : 'black')};
  z-index: ${props => (props.floating ? '2' : '')};
  width: ${props => (props.floating ? '100%' : '')};
  top: ${props => (props.floating ? '0' : '')};
  left: ${props => (props.floating ? '0' : '')};
  right: ${props => (props.floating ? '0' : '')};
`

export const ContentContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  margin: 0 auto;
  max-width: 1100px;
`

const alignX = ['start', 'center', 'end']

export const TwelveColGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: ${props => (props.gap ? props.gap : '1em')};
  justify-content: ${props => (props.alignX && alignX[props.alignX + 1] ? alignX[props.alignX + 1] : 'start')};
`

export const Col = styled.div`
  grid-column: ${props => (props.xSmall ? `span ${props.xSmall}` : 'span 12')};

  @media ${small} {
    grid-column: ${props => (props.small ? `span ${props.small}` : '')};
  }
  @media ${medium} {
    grid-column: ${props => (props.medium ? `span ${props.medium}` : '')};
  }
  @media ${large} {
    grid-column: ${props => (props.large ? `span ${props.large}` : '')};
  }
  @media ${xLarge} {
    grid-column: ${props => (props.xLarge ? `span ${props.xLarge}` : '')};
  }
`

// ICONOGRAPHY
export const ClickableIcon = styled.button`
  font-size: 1rem;
  background: none;
  border: unset;
  cursor: pointer;
  outline: none;
  padding: 0;
  margin: 0;

  & img {
    width: 1.5em;
    height: 1.5em;
  }
`

export const Button = styled.button`
  width: 100%;
  padding: ${globalVariables.padding.button};
  background: ${globalVariables.colors.black};
  border: none;
  color: ${globalVariables.colors.white};
  font-weight: 500;
  margin-bottom: ${globalVariables.spacing.section};
  cursor: pointer;
`

export default GlobalStyle
